import { BifrostBackendNestApi, BifrostBackendApi, BifrostBackendViaCdnApiV2 } from "../../gateways/BifrostBackendApi";
import { store } from "../../store";
import appConfig from "../../appconfig";

export const fetchAllLocalizations = () => {
	return BifrostBackendNestApi.get("/localization/fetchAll", {
		headers: {
			Authorization: store.getters.jwtToken
		}
	}).then((response => {
		return response.data;
	})).catch(() => {
		return {};
	});
};

export const getTenantLocalizations = (useApiCdnCaching) => {
	return (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get("/localization/tenant")
		.then((response => {
			return response.data;
		})).catch(() => {
			return {};
		});
};

export const getTenantGroupLocalizations = (tenantGroup, useApiCdnCaching) => {
	return (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get(`/localization/tenantGroup/${tenantGroup}`)
		.then((response => {
			return response.data;
		})).catch(() => {
			return {};
		});
};

export const changeIsDisabledAndLanguage = (locale, language, flag) => {
	return BifrostBackendNestApi.patch(`/localization/${locale}`, {
		language: language,
		isDisabled: flag
	}, {
		headers: {
			Authorization: store.getters.jwtToken
		}
	});
};

export const getComponentTranslations = (languageCode, component, isAdmin = false, tenantId) => {
	return BifrostBackendNestApi.get(`/localization`, {
		params: {
			languageCode,
			component,
			isAdmin,
			tenantId: tenantId || appConfig.tenantId
		}
	}).then((({ data }) => (
		{
			data
		}
	))).catch(() => {
		return {};
	});
};

export const insertNewLanguage = (locale, catalog, flag, language) => {
	return BifrostBackendApi.post("/localization/", {
		languageCode: locale,
		data: catalog,
		isDisabled: flag,
		language: language
	},
	{
		headers: {
			Authorization: store.getters.jwtToken
		},
		params: {
			tenantId: appConfig.tenantId
		}
	});
};

export const updateCatalog = (locale, catalog) => {
	return BifrostBackendApi.put(`/localization/${locale}`, catalog, {
		headers: {
			Authorization: store.getters.jwtToken
		},
		params: {
			tenantId: appConfig.tenantId
		}
	});
};